import { fieldStyle } from '../venues/venueCreateFields';

/** Static "$" prefix + bare-number input — the value never stores the "$". */
export function PriceInput({
  value,
  error,
  ariaLabel,
  required,
  'aria-describedby': describedBy,
  onChange,
}: {
  value: string;
  error?: string;
  ariaLabel?: string;
  required?: boolean;
  'aria-describedby'?: string;
  onChange: (v: string) => void;
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      <span
        aria-hidden="true"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          height: 32,
          padding: '0 9px',
          fontSize: 12.5,
          color: 'var(--nb-subtle)',
          background: 'var(--nb-bg-2, var(--nb-bg))',
          border: `1px solid ${error ? 'var(--nb-risk)' : 'var(--nb-border-2)'}`,
          borderRight: 'none',
          borderRadius: '8px 0 0 8px',
        }}
      >
        $
      </span>
      <input
        value={value}
        aria-label={ariaLabel}
        aria-required={required}
        aria-describedby={describedBy}
        aria-invalid={error ? true : undefined}
        inputMode="decimal"
        placeholder="0"
        onChange={(e) => onChange(e.target.value)}
        style={fieldStyle(error ? 'error' : undefined, { borderRadius: '0 8px 8px 0' })}
      />
    </div>
  );
}
